import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function PriceRoutes() {
  return (
    <Routes>
      <Route path={Pages.ecom.price.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.ecom.price.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.ecom.price.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.ecom.price.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.ecom.price.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.ecom.price.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
